import { gql } from "@apollo/client";

export const CREATE_PROTECTION_PLAN = gql`
  mutation createProtectionPlan($protectionPlan: ProtectionPlanCreateInput!) {
    createProtectionPlan(protectionPlan: $protectionPlan) {
      id
      name
      description
      excess
      code
    }
  }
`;
